export const HeroSecondaryContent = {
  backgroundWord: 'ПРИЧАЛ',
  leftText: '<strong>малоэтажный квартал </strong> <br>на первой линии Камы',
  rightTitle: 'курортная <br/>жизнь',
  rightText: '<span>в 15 минутах <strong>от центра Перми</strong></span>',
  promo: {
    text: 'квартира месяца <br> с бонусом до 1,8 млн ₽',
    buttonLabel: 'выбрать планировку',
    buttonHref: 'https://prichal-dom.ru/genplan',
  },
};
